import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const CratSwap: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 32 32"
    sx={{
      width: '32px',
      height: '32px',
      fill: 'none',
      color: '#B4EB56',
      ...sx,
    }}
    {...props}
  >
    <path
      d="M28.0017 24.002L24 28.0036"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.0017 28.0036V24.002H24"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.99219 7.99581L7.99385 3.99414"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.99219 3.99414V7.99581H7.99385"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6645 26.6708C16.7163 26.6708 20.0009 23.3862 20.0009 19.3344C20.0009 15.2827 16.7163 11.998 12.6645 11.998C8.61274 11.998 5.32812 15.2827 5.32812 19.3344C5.32812 23.3862 8.61274 26.6708 12.6645 26.6708Z"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.5159 17.8521C27.3809 14.9871 27.3809 10.3419 24.5159 7.4769C21.6508 4.61186 17.0057 4.61186 14.1406 7.4769"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6055 16.3905L15.6067 18.3911C16.1277 18.9119 16.1278 19.7565 15.607 20.2775L13.6064 22.2786C13.0855 22.7995 12.241 22.7997 11.72 22.2788L9.71892 20.2783C9.19796 19.7574 9.19784 18.9129 9.71866 18.3919L11.7192 16.3908C12.24 15.8698 13.0846 15.8697 13.6055 16.3905Z"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export const CratSwapDark: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 32 32"
    sx={{
      width: '24px',
      height: '24px',
      fill: 'none',
      color: '#B4EB56',
      ...sx,
    }}
    {...props}
  >
    <path
      d="M28.0017 24.002L24 28.0036"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.0017 28.0036V24.002H24"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.99219 7.99581L7.99385 3.99414"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.99219 3.99414V7.99581H7.99385"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6645 26.6708C16.7163 26.6708 20.0009 23.3862 20.0009 19.3344C20.0009 15.2827 16.7163 11.998 12.6645 11.998C8.61274 11.998 5.32812 15.2827 5.32812 19.3344C5.32812 23.3862 8.61274 26.6708 12.6645 26.6708Z"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.5159 17.8521C27.3809 14.9871 27.3809 10.3419 24.5159 7.4769C21.6508 4.61186 17.0057 4.61186 14.1406 7.4769"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6055 16.3905L15.6067 18.3911C16.1277 18.9119 16.1278 19.7565 15.607 20.2775L13.6064 22.2786C13.0855 22.7995 12.241 22.7997 11.72 22.2788L9.71892 20.2783C9.19796 19.7574 9.19784 18.9129 9.71866 18.3919L11.7192 16.3908C12.24 15.8698 13.0846 15.8697 13.6055 16.3905Z"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
